import { render } from "./VerifyPayslip.vue?vue&type=template&id=1fd687d9&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./VerifyPayslip.vue?vue&type=script&lang=js"
export * from "./VerifyPayslip.vue?vue&type=script&lang=js"

import "./VerifyPayslip.vue?vue&type=style&index=0&id=1fd687d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd687d9"]])

export default __exports__